import { Platform, StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getWindowDimensions } from '../Utils/Helpers';

export default StyleSheet.create({
  errorIconStyle: {
    marginTop: getWindowDimensions.height > 700 ? -94 : 0,
  },
  screenError: {
    backgroundColor: Colors.transparent,
    height: getWindowDimensions.height * 0.45,
    width: '100%',
    justifyContent: 'center',
  },
  titleStyle: {
    ...Platform.select({
      ios: { marginTop: 24 },
      android: { marginTop: 16 },
    }),
    paddingBottom: 15,
    fontSize: 25,
    ...Fonts.type.bold,
  },
  containerStyle: {
    marginHorizontal: 17,
  },
});
